import React, { memo, type ReactElement, useEffect, useState } from 'react';
import {
  ButtonSelect,
  MenuMulti,
  type MenuOption,
} from '@saviynt/design-system';

import { type SodCustomFilterProps } from './SodCustomFilter';

/**
 * SodStatusFilter component for handling status-based filtering
 * This component provides a dropdown interface for selecting status options
 */
function SodStatusFilter({
  filter,
  activeOptions,
  footerLink1Text,
  footerLink2Text,
  enabledFilterValue,
  setEnabledFilterValue,
  handleOptionsClick,
  handleFilterChange,
  isDisabled,
}: SodCustomFilterProps): ReactElement {
  const [filterOptions, setFilterOptions] = useState<MenuOption[]>(
    filter.options ?? []
  );

  useEffect(() => {
    if (filter.options) {
      setFilterOptions(
        filter.options.map((option) => ({
          ...option,
          isChecked: activeOptions.some(
            (activeOption) => activeOption.value === option.value
          ),
        }))
      );
    }
  }, [filter.options, activeOptions]);

  useEffect(() => {
    const shouldOpenDropdown = Boolean(
      enabledFilterValue && filter.value === enabledFilterValue
    );

    if (shouldOpenDropdown && setEnabledFilterValue) {
      setTimeout(() => {
        setEnabledFilterValue(null);
      }, 200);
    }
  }, [filter.value, enabledFilterValue, setEnabledFilterValue]);

  return (
    <MenuMulti
      key={filter.value}
      options={filterOptions}
      appendLabelsToButton
      label={filter.label}
      onChange={(selectedOptions) => {
        handleOptionsClick(filter.value, filter.method, selectedOptions ?? []);
      }}
      trigger={<ButtonSelect kind='pill' label='' isDisabled={isDisabled} />}
      minOptionsForFooter={0}
      showFooterLink1
      footerLink1Text={footerLink1Text}
      footerLink2Text={footerLink2Text}
      onFooterLink1Click={() => {
        handleFilterChange({
          value: filter.value,
          isChecked: true,
          method: filter.method,
        });
      }}
      onFooterLink2Click={() => {
        handleOptionsClick(filter.value, filter.method, []);
      }}
      isFilteringDisabled
      minOptionsForSearch={0}
      showOptionLabelOnHover
    />
  );
}

export default memo(SodStatusFilter);
